import {HttpError} from '@/services/HttpService';

// The backend's `{error}` message when there is one, else the error's own.
export const backendErrorMessage = (error: unknown): string => {
  if (error instanceof HttpError) return bodyErrorField(error.body) ?? error.body;
  return error instanceof Error ? error.message : String(error);
};

const bodyErrorField = (body: string): string | undefined => {
  try {
    const parsed = JSON.parse(body);
    return typeof parsed?.error === 'string' ? parsed.error : undefined;
  } catch {
    return undefined;
  }
};
